import React from "react";
import HeaderSection from "../components/shared/HeaderSection";
import ContactForm from "../components/pages/homepage/ContactForm";
import { useTranslation } from "react-i18next";
import MetaTags from "../components/shared/MetaTags";

const Contact = () => {
  const { t } = useTranslation();

  return (
    <>
      <MetaTags />
      <HeaderSection title={t("banner.contactus")} />
      <ContactForm showInfoSection={false} />
    </>
  );
};

export default Contact;
